import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {YeuCau} from '../../../../models/yeucau/yeucau';
import {YeuCauService} from '../../../../service/yeucau/service-yeucau';
import {YeuCauFileService} from '../../../../service/yeucau/service-yeucaufile';
import {CommandUtil} from '../../../../global/commandutil';
import {EditYeuCauComponent} from './edit.component';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {ChenHoSoYeuCauComponent} from '../chenhoso/chenhosoyc.component';
import {CTYeuCauComponent} from '../chuyentrinh/chuyentrinhyc.component';
import {XuLyTongHopYeuCauComponent} from '../xuly/yeucau.component';
import {FormatService} from '../../../../service/format/service-format';
import {DatePipe} from '@angular/common';
import {XuLyDetailYeuCauComponent} from '../yeucau/detailyeucau.component';
import {TongHopYKienYeuCauComponent} from '../yeucau/tonghop.component';
import {NavItemService} from '../../../../service/staff/service-navitem';
@Component({
  templateUrl: './yeucaugui.component.html',

})
export class YeuCauGuiComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  @ViewChild(XuLyDetailYeuCauComponent)
  public xuLyYeuCauDetail: XuLyDetailYeuCauComponent;
  public language = language;
  public totalItemsReal: number =0;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public configToolbar: Object = environment.configToolbar;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public dataList: YeuCau[];
  public submitValidate = false;
  public srChuDe: string = '';
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public srStatus: String = '';
  public totalChuaXuLy: number = 0;
  public totalDangXuLy: number = 0;
  public totalHoanThanh: number =0;
  public totalChuaXem: number=0;
  public totalDaXem: number=1;
  public staffId: number = Sessioncommand.staffId;
  public trangThaiSoanThao: number = environment.soanthao;
  public sChuaXuLy: number= environment.chuaxuly;
  public sDangXuLy: number= environment.dangxuly;
  public sHoanThanh: number= environment.hoanthanh;
  public status: number[] =[   environment.chuaxuly,
    environment.dangxuly,
    environment.hoanthanh
  ];
  public srFromDate: Date ;
  public srToDate: Date;
  public strF: string= '';
  public strT: string= '';
  public xem: number = -1;

  public showDetails: boolean = false;
  public yeuCauId: number = 0;
  public nextId: number = 0;
  public trangThaiHoanThanh: number = environment.hoanthanh;
  public dateCurrent: Date = new Date();
  public permission: boolean = false;

  constructor(
    public yeuCauService: YeuCauService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public yeuCauFileService: YeuCauFileService,
    public commandUtil: CommandUtil,
    public formatService: FormatService,
    public datePipe: DatePipe

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {

    this.formatService.getCurrentDateVN().subscribe(x => {
      this.dateCurrent = this.commandUtil.getDate(x);
    });
    this.srStatus = this.status.join();
    this.search();
  }
  public chenHoSo(id: number) {
    const modalEdit = this.bsModalService.show(ChenHoSoYeuCauComponent, {class: 'modal-lg'});
    (<ChenHoSoYeuCauComponent>modalEdit.content).edit(
      id
    );
    (<ChenHoSoYeuCauComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  public yKienTongHop(id: number) {
    const modalEdit = this.bsModalService.show(TongHopYKienYeuCauComponent, {class: 'modal-lg'});
    (<TongHopYKienYeuCauComponent>modalEdit.content).edit(
      id
    );
    (<TongHopYKienYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public detailXuLy(id: number) {
    this.yeuCauId = id;
    this.nextId = this.dataList.findIndex( x => x.id === id);
    this.showDetails = true;
  }
  public nextPage()
  {
    if( this.nextId + 1 >= this.dataList.length)
    {
      if(this.currentPage < this.numPages) {
        this.currentPage = this.currentPage + 1;
        this.yeuCauService.findAllByPaging(this.srChuDe, this.srStatus, this.staffId, this.xem, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          if (this.dataList.length > 0)
          {
            this.yeuCauId = this.dataList[0].id;
            this.nextId = 0;
            this.xuLyYeuCauDetail.edit(this.yeuCauId);
          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId + 1;
      this.yeuCauId = this.dataList [ this.nextId === this.dataList.length ? this.dataList.length -1 : this.nextId ].id;
      this.xuLyYeuCauDetail.edit( this.yeuCauId);
    }
  }
  public backPage()
  {
    if( this.nextId - 1  < 0)
    {
      if(this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
        this.yeuCauService.findAllByPaging(this.srChuDe, this.srStatus, this.staffId, this.xem, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          if (this.dataList.length > 0)
          {
            this.nextId = this.dataList.length - 1;
            this.yeuCauId = this.dataList[this.nextId].id;
            this.xuLyYeuCauDetail.edit(this.yeuCauId);

          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId  - 1;
      this.yeuCauId = this.dataList [ this.nextId === -1 ? 0 : this.nextId].id;
      this.xuLyYeuCauDetail.edit( this.yeuCauId);
    }
  }

  public chuyenTrinh(id: number) {
    const modalEdit = this.bsModalService.show(CTYeuCauComponent, {class: 'modal-lg'});
    (<CTYeuCauComponent>modalEdit.content).edit(
      id
    );
    (<CTYeuCauComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    const modalEdit = this.bsModalService.show(EditYeuCauComponent, {class: 'modal-lg'});
    (<EditYeuCauComponent>modalEdit.content).edit(
      id
    );
    (<EditYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();
      }
    });

  }
  xuLy(id: number) {
    const modalEdit = this.bsModalService.show(XuLyTongHopYeuCauComponent, {class: 'modal-lg'});
    (<XuLyTongHopYeuCauComponent>modalEdit.content).edit(
      id, false
    );
    (<XuLyTongHopYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();
      }
    });

  }
  public loadTotal()
  {
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.yeuCauService.getCountByKeyword(this.srChuDe, environment.chuaxuly.toString(), this.staffId, -1, this.strF, this.strT).subscribe(recordCount => this.totalChuaXuLy = recordCount);
    this.yeuCauService.getCountByKeyword(this.srChuDe, environment.dangxuly.toString(), this.staffId, -1, this.strF, this.strT).subscribe(recordCount => this.totalDangXuLy = recordCount);
    this.yeuCauService.getCountByKeyword(this.srChuDe, environment.hoanthanh.toString(), this.staffId, -1, this.strF, this.strT).subscribe(recordCount => this.totalHoanThanh = recordCount);
    this.yeuCauService.getCountByKeyword(this.srChuDe, this.status.join().toString(), this.staffId, 0, this.strF, this.strT).subscribe(recordCount => this.totalChuaXem = recordCount);
    this.yeuCauService.getCountByKeyword(this.srChuDe, this.status.join().toString(), this.staffId, 1, this.strF, this.strT).subscribe(recordCount => this.totalDaXem = recordCount);
    this.yeuCauService.getCountByKeyword(this.srChuDe, this.status.join().toString(), this.staffId, -1, this.strF, this.strT).subscribe(recordCount => this.totalItemsReal = recordCount);
  }
  search()
  {
    this.loadTotal();
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.yeuCauService.findAllByPaging(this.srChuDe, this.srStatus, this.staffId, this.xem, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.yeuCauService.getCountByKeyword(this.srChuDe, this.srStatus, this.staffId, this.xem, this.strF, this.strT).subscribe(recordCount => this.totalItems = recordCount);
  }


  deleteItem(id: number)
  {
    this.yeuCauService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();
        Sessioncommand.giaiQuyetSuVuStatus = 0;

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

